module.exports = __webpack_public_path__ + "img/T1B_rc_30.440965ed.png";